import { createFileRoute } from "@tanstack/react-router";
import { AdminRecoverRequestPage } from "@/components/admin/AdminRecoverRequestPage";

export const Route = createFileRoute("/pulse-ops-x7k2/recover")({
  component: AdminRecoverRequestPage,
});
